export default "__VITE_ASSET__68cdef7f__"